import FollowUpTable from './FollowUpTable'

export * from './FollowUpTable'
export default FollowUpTable
